// extracted by mini-css-extract-plugin
export default {"tipContainer":"k7bNlM","tipDescription":"L7B_E_","link":"NBqBfR"};